import { createMapAction } from "chalet-shared";

import { RoomView } from "../reducers/rooms";
import { Data } from "../service/Data";

export const actionCreators = {
    globalSearchRequested: createMapAction(
        "GLOBAL_SEARCH_REQUESTED",
        (x: { roomView: RoomView; searchQuery: string; cursor?: number }) => x
    ),
    globalSearchSuccess: createMapAction(
        "GLOBAL_SEARCH_SUCCESS",
        (x: { roomView: RoomView; data: Data.SearchIn }) => x
    ),
    globalSearchFail: createMapAction("GLOBAL_SEARCH_FAIL", (x: { err: any }) => x),
};
